
export default {
  "m":{
    "sms_login":"Вход в систему с помощью SMS",
    "get_vercode":"Отправить",
    "change_mobile":"Изменить номер мобильного телефона",
    "log_reg_agree":"Вход/Регистрация означает согласие {msg_ss}",
    "old_mobile":"Оригинальный номер мобильного телефона",
    "new_mobile":"Новый номер мобильного телефона",
    "agency_reginfo_fill":"Заполните регистрационную информацию о гильдии",
    "audit_res":"Результат аудита",
    "agency_name":"Название агентства",
    "agency_name_input":"Пожалуйста, введите название агентства",
    "agency_name_input_note":"Примечание: Название агентства рекомендуется делать коротким и легко запоминающимся, не более 30 слов",
    "agency_logo":"ЛОГОТИП ГРУППЫ",
    "agency_logo_unpload_note":"Пожалуйста, загрузите четкий логотип вашего агентства, поддерживайте формат PNG/JPG/JPEG",
    "agency_contact_name":"Контактное лицо агентства",
    "user_contact_name":"Пожалуйста, укажите имя человека, который находится в ежедневном контакте с пользователем платформы",
    "agency_contact_phone":"Контактный телефон агентства",
    "agency_whatsapp":"WhatsApp агента",
    "agency_whatsapp_contact":"Пожалуйста, введите контактную информацию агента в WhatsApp",
    "agency_use_lang":"Язык агента",
    "agency_head_ID":"Идентификатор агента",
    "agency_ID_input":"Пожалуйста, введите идентификатор пользователя приложения BuzzCast для агента, который будет использоваться для распределения средств позже.",
    "reg_country":"Страна регистрации",
    "inhand_ID_photo":"Удостоверение личности с фотографией под рукой",
    "upload_note_t":"Примечание для загрузки",
    "agency_self_inhand_ID":"Должен быть взят самим агентом вместе с паспортным документом",
    "photo_must_clearly":"На лицевой стороне должно быть четко указано лицо и фактические паспортные данные",
    "mian_form_country":"Основная страна происхождения стримера",
    "invite_code":"Код приглашения",
    "your_profile_submit_success":"Ваш документ успешно отправлен! мы разберемся с этим как можно скорее.<br>Результаты аудита будут отправлены в уведомление лидера гильдии BuzzCast APP, и, пожалуйста, обратите внимание на проверку!",
    "your_profile_approved":"Ваша заявка не была одобрена! Причина отказа: \"Фотография с рукой не четкая\".<br>Пожалуйста, заполните форму еще раз или свяжитесь с официальным ассистентом BuzzCastAPP для получения дополнительной информации.",
    "return_refill":"Вернуться для повторного завершения",
    "success_agency":"Поздравляю с успешным вступлением на платформу, [нажмите на меня] и приступайте к работе!",
    "personal_account":"Лицевой счет",
    "my_agency":"Мое агентство",
    "your_agency_been_forcibly":"Ваше агентство было принудительно прекращено платформой, и вы больше не сможете войти в систему. Если у вас возникли вопросы, пожалуйста, свяжитесь с официальным помощником BuzzCastAPP или эксклюзивной операцией.",
    "invite_live_join":"Пригласить стримера присоединиться к агентской ссылке",
    "base_info":"Основная информация",
    "apply_time":"Время применения",
    "join_time":"Время присоединения",
    "cooper_status":"Статус сотрудничества",
    "streamer_manage":"Управление стримерами",
    "sereamer_apply":"Утверждение стримеров",
    "sereamer_nickname":"Прозвище стримера",
    "remark":"Комментарии",
    "no_remark":"Нет комментариев",
    "add_remark":"Добавить комментарий",
    "birth":"Год рождения",
    "user_status":"Статус пользователя",
    "temporarily_frozen":"Временно заморожен",
    "permanently_frozen":"Постоянно замороженные",
    "fans_num":"Количество Подписчиков",
    "sign_status":"Статус подписки",
    "sign_ing":"По контракту",
    "sign_time":"Время подписки",
    "release_time":"Время выхода",
    "live_viola_record":"Запись нарушений в реальном времени",
    "sign_record":"Запись подписи",
    "current_contract_status":"Текущий статус контракта",
    "termination_reason":"Причина увольнения",
    "violation_reason":"Причина нарушения",
    "violation_time":"Время нарушения",
    "processing_result":"Результат обработки",
    "exported_data":"Экспортированные данные",
    "join_agency_apply":"Разрешение на вступление в агентство",
    "audit_status":"Статус аудита",
    "pending_review":"В ожидании",
    "pending_HQ_review":"Ожидает рассмотрения головным офисом",
    "not_approved_HQ":"Не утверждено головным офисом",
    "withdrawn":"Отозвано",
    "audit_trail":"Аудиторская запись",
    "oper":"Операция",
    "other_video_materials":"Другие видеоматериалы",
    "pass":"Пройти",
    "pass_streamer_join_agency_apply":"Утвердить заявление о членстве якоря",
    "reject_streamer_join_agency_apply":"Отклонен запрос на присоединение якоря",
    "agree_streamer_join_agency":"Согласие с ведущим {msg_ss1} стать ведущим ниже {msg_ss2}~",
    "reject_streamer_join_agency":"Отклонение запроса от члена {msg_ss1} стать членом {msg_ss2}!",
    "img_material":"Фотоматериал",
    "approver":"Утверждающий",
    'user_enter_bind_phone':'Пожалуйста, введите номер телефона',
    'vericode':'Проверочный код',
    'input_vericode':'Пожалуйста, введите проверочный код',
    'login':'Авторизоваться',
    'reg':'Зарегистрировано',
    'logout':'Выйти',
    'search_for':'Поиск',
    'subscription_closed':'Аннулированный контракт',
    'agency_ID':'Код гильдии: {msg_ss}',
    'reset':'Сброс',
    'live_ID':'Прямая трансляция номера комнаты',
    'live_record':'Запись живого экрана',
    'email':'Электронная почта',
    'phone':'Мобильный номер',
    'mastery_lang':'Владение языком',
    'to':'В',
    'cancel':'Отмена',
    'Confirm':'ХОРОШО',
    'preview':'Предварительный просмотр',
    'rejected':'Отклонено',
    'tip':'Подсказка',
    'i_got_it':'Я понял',
    'cancelled':'Отменено',
    'refused':'Отказаться',
    'agency_agree':'Агентство согласилось',
    'platform_agree':'Платформа согласилась',
    'user_not_exist':'Этот пользователь не существует',
    'user_frozen':'Этот пользователь заморожен',
    'reviewing':'В обзоре',
    'review_pass':'Просмотрение пройдено',
    'review_failed':'Аудит не удалось',
    'xx_hours':'{msg_ss} часов',
    'xx_days':'{msg_ss} дней',
    'xx_hour': '{msg_ss} час',
    'xx_day': '{msg_ss} день',
    'xx_year': '{msg_ss} год',
    'xx_years': '{msg_ss} годы',
    'check_phone_istrue':'Пожалуйста, проверьте номер телефона, правильно ли он введен',
    'male':'Мужчина',
    'female':'Женщина',
    'avatar':'Портрет',
    'normal':'Нормальный',
    'live_room':'Живая комната',
    'view':'Посмотреть',
    'oper_success':'Успешная операция',
    'copy_success':'Успешная копия',
    'new_mobile_already_reg':'Зарегистрирован новый номер мобильного телефона',
    'general_user':'Обычный пользователь',

    'copy':'Копия',
    'gender':'Пол',
    'submit':'Отправить',
    'permanent':'Перманентный',
    'agree_agreement':'Согласен и соблюдаю договор',
    'vericode_error':'Код проверки неправильный',
    'resend':'Отменить похвалы',
    'approved':'Одобрено',
    'not_approved':'Неудачный',
    'agency_rejected':'Платформа отклонена',
    'select':'Выбрать',
    'search':'Поиск',
    'rejection_reason':'Причина отказа',
    'no_data':'Нет данных',
    'oper_failed':'Операция не удалась',
    'leave_agency_apply':'Согласие на увольнение из агентства',
    'over_word_limit':'Превышен лимит слов',
    'delete':'Удалять',
    'nickname':'Имя пользователя',
    'file_is_too_large':'Слишком большой файл',

    'community_convention':'Конвенция сообщества Buzzcast',
    'approval_time':'Время проверки',
    'guild_system_title':'Система гильдий платформы социального контакта BuzzCast',
    'return':'Назад',
    'img_upload_fail':'Не удалось загрузить изображение',
    'cooper_ing':'В сотрудничестве',
    'upload_file_format_incorrect':'Загруженный файл имеет неверный формат',
    'token_invalid':'Токен недействителен, пожалуйста, войдите снова!',
    'network_busy':'Сеть занята, пожалуйста, попробуйте еще раз',
    'minute':'{msg_ss}минута',

    'live_room_ID':'ID комнаты для прямого эфира',
    'scan_code':'Сканируйте код для входа в BuzzCast APP',
    'open_code':'Откройте BuzzCastApp и нажмите Мой QR-код для сканирования',
    'refresh':'Обновлять',
    'login_confirm':'Подтверждайте входа в систему',
    'account':'Информация об учетной записи',
    'user_name':'Имя пользователя',
    'edit':'Изменять',
    'changing':'Изменять привязанную учетную запись',
    'mobile_number':'Учетная запись мобильного телефона',
    'mobile_login':'Вы можете войти в систему, используя номер мобильного телефона {msg_ss}',
    'appId_login':'Вы можете использовать AppID [{msg_ss}] для сканирования для входа в систему',
    'code_login':'BuzzCastApp ID не привязан, и вы можете использовать QR-код для сканирования кода для входа в систему после привязки',
    'verification_log':'Номер мобильного телефона не привязан, и вы можете использовать номер мобильного телефона и проверочный код для входа в систему после привязки',
    'binding_success':'Привязка удалась',
    'binding_mobile':'Привязать номер телефона',
    'edit_name':'Изменять имя пользователя',
    'binding_alert':'Подсказка о изменение привязанную учетную запись',
    'new_appId':'Непосредственно используйте новый APPID для сканирования привязки кода, исходный APPID будет непосредственно заменен',
    'binding_account':'Привязать учетную запись BuzzCastApp',
    'anchor_earings':'Доход ведущего',
    'signing_date':'Дата подписания',
    'statistical_date':'Дата составления статистических данных',
    'valid_min':'Общее действительнее время (минута)',
    'valid_day':'Действительные дни',
    'total_revenue':'Общий доход',

    'bind':'Cвязывать',
    'please_agree_agree':'Пожалуйста, примите соглашение',
    'note':'Примечание: Все время, указанное в данной системе, соответствует времени Нью-Йорка, США (EST).',
    'app_phone':'Зарегистрируйте номер мобильного телефона APP',
    'host_num':'Количество хостов',
    'enter_host_num':'Пожалуйста, введите его номер всех хостов',
    'platform':'Платформа сотрудничества',
    'statement':'Ежемесячная выписка из банка',
    'enter_income':'Пожалуйста, введите среднемесячный доход',
    'check_commas':'Неправильный формат. Пожалуйста, проверьте, разделены ли несколько платформ запятыми',
    'submit_success':'Ваш документ успешно отправлен! мы разберемся с этим как можно скорее',
    'usd':'долларов',
    'many_platforms':'Пожалуйста, укажите платформу прямых трансляций, с которой вы сотрудничали ранее, до 20 платформ.',
    'limit_platform': 'До 20 платформ',
    'user_has_delete':'Пользователь вышел из системы',
    'cant_commit':'Вы уже являетесь контрактным ведущим и не можете одновременно подать заявку на создание гильдии',
    'cant_commit_1':'Вы уже подаваете заявку на то, чтобы стать контрактным ведущим, и вы не можете одновременно подать заявку на создание гильдии',
    'passwd': 'Пароль',
    'passwd_placeholder': 'Ваш пароль должен быть от 6 до 20',
    'live_rights': 'Оценка без времени',
    'edit_log': 'Изменить запись',
    'edit_time': 'Изменить время',
    'edit_pwd': 'Изменить пароль',
    'old_pwd': 'Старый пароль',
    'new_pwd': 'Новый пароль',
    'confirm_pwd': 'Подтверждать пароль',
    'forget_pwd': 'Забыл пароль? ',
    'email_check': 'Неверный формат электронной почты',
    'phone_pwd_error': 'ошибки в номере телефона или пароли',
    'ten_min_error': 'Пожалуйста, попробуйте еще раз через 10 минут',
    'phone_bind_error': 'Номер мобильного телефона был привязан к другим учетным записям, замените новый номер мобильного телефона для привязки.',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'ID лидера гильдии уже заполнен, пожалуйста, заполните еще раз',
    'pwd_error': 'неверный пароль',
    'phone_not_reg_error': 'Учетная запись не зарегистрирована',
    'pwd_nq': 'Новые введенные пароли не соответствуют друг другу',
    'sign_anchor_error': 'Вы уже являетесь контрактным вещателем и не можете одновременно подать заявку на поселение в гильдию',
    'apply_anchor_error': 'Вы уже подали заявку на работу с контрактным вещателем, и вы не можете одновременно подать заявку на поселение в гильдию',
    'have-expired':'Просроченный',
    'approval-time':'Срок утверждения',
    'reasons-for-refusal':'Пожалуйста,введите причину отказа',
    'Transfer-grounds':'Причина перевода',
    'code_expire': 'Срок действия кода проверки истек, пожалуйста, нажмите на него для обновления',
    'transfer-approval':'Утверждение перевода',
    'live_state_placeholder': 'В прямом эфире',
    'live_state_open': 'Нормально',
    'live_state_temporary_banned': 'Прямой эфир заблокирован',
    'live_state_forever_banned': 'Прямой эфир заблокирован навсегда',
    'live_allowed_time': 'Разрешенное время начала эфира',
    'live_banned_time': 'Срок заблокирования',
    'deduct_money': 'Вычесть количество монет B',
    'final_income': 'Реальные доходы',
    'select_start_dt': 'Пожалуйста, выберите время начала',
    'select_end_dt': 'Пожалуйста, выберите время окончания',
    'less_then_end_dt': 'Время начала должно быть меньше или равно времени окончания',
    'System_automatically_through':'Система автоматически проходит',
    'btrade_err': 'ID агентства недоступен',

    'mouth_anchor': 'ведущий с ежемесячной оплатой',
    'day_anchor': 'ведущий с ежедневной оплатой',
    'guild_anchor': 'Награда главы гильдии (ежедневная оплата)',
    'mouth_anchor_st': 'Время начала ежемесячной оплаты',
    'mouth_anchor_et': 'Время завершения  ежемесячной оплаты',
    'day_anchor_st': 'Время начала ежедневной оплаты',
    'day_anchor_et': 'Время завершения  ежемесячной оплаты',
    'all_award_bcoin': 'Общий доход от ежедневной награды',
    'live_hour': 'Награда за эффективное время прямого эфира',
    'salary_day': 'Дата',
    'day_in_come': 'Дневной доход гильдии (B-Монеты)',
    'award_ration_flag_str': 'Процент награды',
    'payable_money': 'Награда главы гильдии в B-монетах',
    'host_bcoins': 'Ведущии доход В монетах',
    'total_official': 'Общее количество официальных наградных В монет',
    'actual_bcoins_awarded': 'Фактическая награда В монетах',
    "change_bound_account":"Измените привязанную учетную запись" ,
    "agent_id_form":"Удостоверение личности президента гильдии:" ,
    "BuzzCast_verification_code":"Проверочный код BuzzCast:" ,
    "send_success":"Успешная отправка" ,
    "account_changed_successfully":"Привязанный аккунт был успешно заменена." ,
    "invite_guild_url":"Ссылка на приглашение стать президентом гильдии BuzzCast:{msg_ss}" ,
    "invite_guild_code":"Мой пригласительный код: {msg_ss}" ,
    "save":"Сохранить" ,
    "compile":"Редактировать" ,
    "agent_nvitation_eward":"Президент гильдии предлагает награды" ,
    "agent_name":"Ник председатель гильдии" ,
    "guild_id":"Номер гилдия" ,
    "guild_income_30days":"За 30 дней доходы" ,
    "guild_invite_income_30days":"Приглашение доход на 30 дней" ,
    "agency_commission_ratio":"Процент агентской комиссии" ,
    "invite_income_bcoins":"Приглашение вознаграждает B монетами" ,
    "id_not_exist": "Ид не существует",
    'reward_distribution_status': 'Статус распределения вознаграждений',
    'must_number': 'Ваш ввод должен быть в чисто числовом формате.',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/ru.js